// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__sb1ex","right":"Footer_right__2g4mQ","buttons":"Footer_buttons__3EoC5"};